module.exports = __webpack_public_path__ + "static/media/icon-roomready-cropped.3c018e6a.png";